import { createSelector } from '@reduxjs/toolkit';

import { modelItemsSelector } from 'src/selectors/modelItems';
import { namedGraphsSelector } from 'src/selectors/namedGraphs';
import { SPECIAL_NAMED_GRAPH_IRIS } from 'src/templates/queries/iris';

/**
 * Models that can be replaced in the Publish ModelSelector.
 *
 * Returns the same items as modelItemsSelector, but modifies `namedGraphIris` to contain
 * only named graphs that are modifiable by filtering out:
 * - alias graphs
 * - virtual graphs
 * - special graphs (tag:stardog:api:context:local, etc)
 */
export const replaceableModelItemsSelector = (databaseId: string) =>
  createSelector(
    modelItemsSelector(databaseId),
    namedGraphsSelector(databaseId),
    (modelItems, namedGraphs) =>
      modelItems.map((item) => ({
        ...item,
        namedGraphIris: item.namedGraphIris.filter((iri) => {
          const namedGraph = namedGraphs[iri];
          return (
            // ALLOW empty graphs
            !namedGraph ||
            (!namedGraph.isAlias &&
              !namedGraph.isVirtual &&
              !SPECIAL_NAMED_GRAPH_IRIS.includes(namedGraph.iri))
          );
        }),
      }))
  );
